// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUndeliverableAddressBreakdownRecordDto
 */
export interface IUndeliverableAddressBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employment_status_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    mailing_address1?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    mailing_address2?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    mailing_city?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    mailing_state?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    mailing_zip?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IUndeliverableAddressBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IUndeliverableAddressBreakdownRecordDto interface.
 */
export function instanceOfIUndeliverableAddressBreakdownRecordDto(value: object): value is IUndeliverableAddressBreakdownRecordDto {
    return true;
}

export function IUndeliverableAddressBreakdownRecordDtoFromJSON(json: any): IUndeliverableAddressBreakdownRecordDto {
    return IUndeliverableAddressBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IUndeliverableAddressBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUndeliverableAddressBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employment_status_date': json['employment_status_date'] == null ? undefined : (new Date(json['employment_status_date'])),
        'mailing_address1': json['mailing_address1'] == null ? undefined : json['mailing_address1'],
        'mailing_address2': json['mailing_address2'] == null ? undefined : json['mailing_address2'],
        'mailing_city': json['mailing_city'] == null ? undefined : json['mailing_city'],
        'mailing_state': json['mailing_state'] == null ? undefined : json['mailing_state'],
        'mailing_zip': json['mailing_zip'] == null ? undefined : json['mailing_zip'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IUndeliverableAddressBreakdownRecordDtoToJSON(json: any): IUndeliverableAddressBreakdownRecordDto {
    return IUndeliverableAddressBreakdownRecordDtoToJSONTyped(json, false);
}

export function IUndeliverableAddressBreakdownRecordDtoToJSONTyped(value?: IUndeliverableAddressBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employment_status': value['employment_status'],
        'employment_status_date': value['employment_status_date'] == null ? undefined : ((value['employment_status_date']).toISOString().substring(0,10)),
        'mailing_address1': value['mailing_address1'],
        'mailing_address2': value['mailing_address2'],
        'mailing_city': value['mailing_city'],
        'mailing_state': value['mailing_state'],
        'mailing_zip': value['mailing_zip'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

